import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { priceSourceOptions } from '../../data'
import PriceSourceLink from '../price/PriceSourceLink'
import DropDown from '../button/DropDown'
import { priceSourceDefaults, translationsMapping } from '../../../config'
import translate from '../../helper/translate'
import { mobile } from '../../styles/media'

const PrintDropDown = ({ button, cardSlug, print, setNumber, t, userLanguage }) => {
	const priceSourceDefault = priceSourceDefaults[translationsMapping[userLanguage]]

	return (
		<StyledPrintDropDown>
			<DropDown
				button={button}
				top={38}
			>
				{() => (
					<>
						{priceSourceOptions(priceSourceDefault).filter(item => item.affiliate).map(item => (
							<PriceSourceLink
								button
								printId={print.id}
								externalLink={print.externalLinks ? print.externalLinks[item.value] : null}
								priceSource={Number(item.value)}
								key={item.value}
							>
								<span>
									{t('general.showOnPriceSource', { priceSource: <strong>{item.name}</strong> })}
								</span>
							</PriceSourceLink>
						))}
					</>
				)}
			</DropDown>
		</StyledPrintDropDown>
	)
}

PrintDropDown.propTypes = {
	button: PropTypes.any.isRequired,
	cardSlug: PropTypes.string.isRequired,
	print: PropTypes.object.isRequired,
	setNumber: PropTypes.string,
	t: PropTypes.func.isRequired,
	userLanguage: PropTypes.string.isRequired
}

PrintDropDown.defaultProps = {
	setNumber: null
}

export const StyledPrintDropDown = styled.div`
	position: absolute;
	right: 0;
	opacity: 0;

	background: ${props => props.theme.backgroundVeryLight};
	height: 46px;
	width: 100px;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	padding: 0 1rem;

	${mobile`
		display: none;
	`}
`

const enhance = compose(
	connect(state => ({
		userLanguage: state.persist.language
	})),
	translate('general')
)

export default enhance(PrintDropDown)
